<kv-editor-container [menuItems]="menuItems" [title]="title" menuTag="menuTag" [menuGroups]="menuGroups" [inputComponent]="inputComponent"></kv-editor-container>
